import { RootState } from "@/app/stores";
import { createOrder, getPair, getPairGlass, IGetPairChartResults, IPairGlass, ITradingPair, getPairChart } from "@/shared/api/trading";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchPair = createAsyncThunk<
    ITradingPair,
    string,
    { state: RootState }
>(`socialMarketPair/fetchPair`, async (id, thunkAPI) => {
    try {
        const response = await getPair(id)
        return response.data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

interface ICreateOrderRequest {
    ord_type: "limit" | "market"
    quantity: number
    price?: number
}

export const fetchCreateOrder = createAsyncThunk<
    void,
    ICreateOrderRequest,
    { state: RootState }
>(`socialMarketPair/createOrder`, async (data, thunkAPI) => {
    try {
        const { pair } = thunkAPI.getState().socialMarketPair
        const { community } = thunkAPI.getState().community

        let side: "buy" | "sell"

        switch(community.type) {
        case "manufacturer":
        case "partner":
            side = "sell"
            break;
        case "foundation":
            side = "buy"
            break;
        default:
            side = "buy"
            break;
        }

        const response = await createOrder({
            side,
            ord_type: data.ord_type,
            pair_id: pair.id,
            quantity: data.quantity,
            price: data.price
        })
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchPairChart = createAsyncThunk<
    IGetPairChartResults,
    void,
    { state: RootState }
>('socialMarketPair/fetchPairChart', async (_, thunkAPI) => {
    try {
        const { pair, chartCount, chartInterval } = thunkAPI.getState().socialMarketPair
        const response = await getPairChart(pair.id, chartCount, chartInterval)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchPairGlass = createAsyncThunk<
    IPairGlass,
    void,
    { state: RootState }
>('socialMarketPair/fetchPairGlass', async (_, thunkAPI) => {
    try {
        const { pair } = thunkAPI.getState().socialMarketPair
        const response = await getPairGlass(pair.id)
        return response.data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})